// @flow
export const ADD_DEVICE = 'd';
export const BATTERY_EMPTY = 'O';
export const BATTERY_FULL = 'R';
export const BATTERY_LOW = 'P';
export const BATTERY_NORMAL = 'Q';
export const BOOST = 'F';
export const BORD_GAIS = 'Z';
export const BRITISH_GAS = 'Y';
export const BULB_TUNER = '"';
export const CALL = 'L';
export const CIRCLE_FILLED = '5';
export const CIRCLE_OUTLINE = '4';
export const COLOUR_PICKER = '#';
export const CLOSE = 'E';
export const CLOSE_HEAVY = '}';
export const CONNECTED = 'M';
export const CONTROLS = '3';
export const COPY = 'H';
export const CREATE = '^';
export const CREATE_PLUS = '_';
export const DASHBOARD = 'a';
export const DEMO = 'j';
export const DEVICE_MENU = 'c';
export const DIMMER = '!';
export const DOWN = 'B';
export const DOWNLOAD = 's';
export const EDIT = 'I';
export const EXCLAMATION = 'x';
export const FROST = 'N';
export const GRAPHS = '2';
export const HEATING = 'p';
export const HELP = 'l';
export const HIVE = 'X';
export const HOLIDAY = 'v';
export const HOME = 'u';
export const HOT_WATER = 'o';
export const INFO = 'w';
export const INSTALL_DEVICE = 'n';
export const LEFT = 'y';
export const LINKED = '6';
export const LOGOUT = 't';
export const MANAGE_DEVICE = 'h';
export const MENU = 'b';
export const MIC_OFF = '=';
export const MIC_ON = '+';
export const MINUS = 'g';
export const MORE = 'e';
export const MOOD_HAPPY = '%';
export const MOOD_SUNSET = '(';
export const MOOD_ZEN = '$';
export const MORE_CIRCLE = '&';
export const MULTI_PROFILE = '0';
export const NOTIFICATIONS_OFF = 'r';
export const NOTIFICATIONS_ON = 'q';
export const PET_MODE = ')';
export const PLUS = 'f';
export const PLUS_CIRCLE = 'd';
export const PROFILE = 'J';
export const QUESTION = '9'; //rules
export const RECIPES = 'm'; //rules
export const RESET = 'K';
export const RIGHT = 'z';
export const SCHEDULE = '1';
export const SETTINGS = 'i';
export const SEARCH = '8';
export const SHOP = 'k';
export const SIGNAL_BAR_0 = 'S';
export const SIGNAL_BAR_1 = 'T';
export const SIGNAL_BAR_2 = 'U';
export const SIGNAL_BAR_3 = 'V';
export const SIGNAL_BAR_4 = 'W';
export const SOUND_OFF = ',';
export const SOUND_ON = '<';
export const TICK = 'D';
export const TICK_CIRCLE = 'C';
export const TONE = '"';
export const TRASH = 'G';
export const UNLINKED = '7';
export const UP = 'A';



// WEBPACK FOOTER //
// ./src/core/constants/icons/general.js